import styled from 'styled-components';

export const SearchWrap = styled.div`
    // position: absolute;
    // top: 24px;
    // right: 65px;
    z-index: 10000;
    color: #fff;
`;

export const SearchToggle = styled.div`
    width: 22px;
    height: 23px;
    background: transparent;
    position: relative;
    left: 50%;
    top: 50%;
    transform: translate(-75%, 0%);
    border: 0;
    cursor: pointer;

    &:focus {
        outline: none;
    }

    &:active {
        opacity: 0.3;
    }
`;

export const SearchBodyWrapper = styled.div`
    position: fixed;
    background: 0 0 black;
    width: 100vw;
    height: 46px;
    top: 11px;
    left: 0;
    transform: translateX(100%);
    opacity: 0;
    overflow: hidden;
    transition: all 0.4s ease, height 0.4s ease 0.4s;
    z-index: 1;

    ${props => {
        if (props.isActive) {
            return `
                transform: translateX(0%);
                height: 291px;
                opacity: 1;

                @media (min-width: 768px) {
                  transform: translateX(-50%);
                }

            `;
        }
    }};

    @media (min-width: 768px) {
        width: 85%;
        border-radius: 4px;
        border: 1px solid #333333;
        left: 50%;
    }

    @media (min-width: 870px) {
        width: 90%;
    }

    @media (min-width: 1140px) {
        left: 65%;
        width: 65%;
    }
`;

export const SearchBtnClose = styled.div`
    position: absolute;
    top: 50%;
    right: 0;
    transform: translate(-70%, -50%);
    display: flex;
    flex-direction: column;
    justify-content: center;
    background: transparent;
    background: none;
    width: 20px;
    height: 20px;
    border: 0;
    cursor: pointer;

    &:focus {
        outline: none;
    }

    &:active {
        opacity: 0.3;
    }
`;

export const SearchInputWrap = styled.div`
    position: relative;
    width: 100%;
    padding: 10px;
    box-sizing: border-box;
    margin-bottom: 15px;

    & > input {
        width: 100%;
        box-sizing: border-box;
        border: 0;
        font-family: Helvetica;
        font-size: 14px;
        font-weight: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        color: #909fac;
        border-radius: 2px;
        padding: 5px 30px 5px 5px;
        background-color: rgba(239, 240, 242, 0.18);

        &:focus {
            outline: none;
        }
    }
`;

export const SearchUsersListWrap = styled.div`
    & > div {
        padding: 0px 10px;
    }

    & .infinite-scroll-component {
        flex-direction: row;
        max-width: 100%;
        box-sizing: border-box;
        align-items: flex-start;
        align-content: flex-start;

        &::-webkit-scrollbar-track {
            background: #000;
        }

        &::-webkit-scrollbar {
            width: 10px;
            background: #000;
        }

        &::-webkit-scrollbar-thumb {
            border-radius: 10px;
            border: 1px solid #333333;
            background: #000;
        }
    }
`;

export const SearchUserWrap = styled.div`
    display: flex;
    align-items: center;
    padding: 5px 10px;
    width: 100%;

    a {
        display: flex;
        align-items: center;
        cursor: pointer;
    }
`;

export const SearchUserIconWrap = styled.div`
    position: relative;
    margin-right: 20px;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    border: 2px solid #797979;
    overflow: hidden;

    svg {
        width: 32px;
        height: 32px;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
    }
`;

export const SearchUserIcon = styled.div`
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    ${props => `background-image: url(${props.url})`};
`;

export const SearchUserName = styled.div`
    font-family: Rubik;
    font-size: 14px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1;
    letter-spacing: normal;
    color: #ffffff;
`;

export const SearchNotFoundWrap = styled.div`
    width: 220px;
    margin: 0 auto;
    font-family: Rubik;
    font-size: 12px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.33;
    letter-spacing: normal;
    text-align: center;
    color: rgba(255, 255, 255, 0.85);
    padding: 30px 0px;
`;

export const SearchNotFoundIcon = styled.div`
    display: flex;
    justify-content: center;
    margin-bottom: 10px;
`;

export const SearchNotFoundTitle = styled.div`
    opacity: 0.9;
    font-family: Rubik;
    font-size: 16px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    color: #ffffff;
    margin-bottom: 9px;
`;

export const SearchNotFoundDesc = styled.div`
    font-family: Rubik;
    font-size: 12px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.33;
    letter-spacing: normal;
    text-align: center;
    color: rgba(255, 255, 255, 0.85);
`;

export const LoadingWrap = styled.div`
    font-family: Rubik;
    font-size: 12px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1;
    letter-spacing: normal;
    color: #ffffff;
    padding: 10px;
    text-align: center;
    text-transform: uppercase;
    width: 100%;
`;



// WEBPACK FOOTER //
// ./src/UI/Containers/Search/style.js